import $ from "jquery";

function initFilter($bl, $blResults) {
    function hideAllItems() {
        //console.log("hide all");
        $blResults.find(".item").hide();
    }

    function showAllItems() {
        //console.log("show all");
        $blResults.find(".item").fadeIn(200);
    }

    function showItemContainingCategory(category, value) {
        //console.log("show: "+category+"="+value);
        $blResults.find(".item[data-filter-"+category+"='"+value+"']").fadeIn(200);
    }

    function updateFilter() {
        if($bl.find("input:checked").length == 0) {
            //All checkboxes unchecked => show all items
            showAllItems();
            return;
        }

        //First, hide all
        hideAllItems();
        
        //Then show all, category by category
        $bl.find(".filtercategory").each(function() {
            const $category = $(this);
            const field = $category.data("field");
            const $checkedInputs = $category.find("input:checked");
            /*const values = $checkedInputs.map(function() {
                return $(this).attr("value");
            }).get();*/
            $checkedInputs.each(function() {
                const value = $(this).val();
                showItemContainingCategory(field, value);
            })
        });
    }

    $bl.on("click", "input[type=checkbox]", updateFilter);
}

$(function() {
    $(".bl-objectfilter").each(function() {
        const $bl = $(this);
        const $blResults = $bl.next(".bl-objectfilterresults");
        initFilter($bl, $blResults);
    });
});